import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';

const formatUserResult = (user, index = 0, page, limit) => ({
  // No: ((page - 1) * limit) + (index + 1),
  No: index + 1,
  FullName: `${user.user?.last_name || ''} ${user.user?.first_name || ''}`.trim(),
  Gender: `${user.user?.gender_id == 1? "Male" : "Femail"}`,
  Generation: `${user.user?.generation || ""}`,
  Date: moment(user.created_at).format("DD-MMM-YYYY"),
  Reading: `${user.result?.reading}/${user.result?.total_reading}`,
  Listening: `${user.result?.listen}/${user.result?.total_listing}`,
  Total: `${(user.result.listen + user.result.reading) * 2.5}`,
  BlindTest: `${user.result?.blind_test}/${user.result?.total_blind_test}`
});

export const exportUserTestResultToExcel = (rawData, filename, page, limit) => {

  const flatData = rawData.map((user, index) =>
    formatUserResult(user, index, page, limit)
  );

  const worksheet = XLSX.utils.json_to_sheet(flatData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, filename);
};
